import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { getToken } from '@/utils/auth' // 验权
import { getMachineId, setMachineId } from '@/utils/global'
import thirdpartyAuth from '@/utils/thirdpartyAuth'
import { wxGetConnectUrl, aliGetConnectUrl } from '@/api/login';
import { browser, ACCESS_PLATFORM } from "@/utils/util";

const whiteList = ['/buy']
const authList = ['/order', '/tryLogin', '/orders']

router.beforeEach(async (to, from, next) => {

  if(to.query.machineId) {
    console.log(1111);
    setMachineId(to.query.machineId);
  }

  if (process.env.NODE_ENV === 'production') {
    if (!browser.accessAllowed) {
      next(false);
    }
  }

  console.log('to.path', to.path)
  if (to.path === '/index') {
    return next()
  }

  // 在白名单，直接进入
  if (whiteList.indexOf(to.path) !== -1) {
    return next()
  }
  // console.log('不在白名单，校验登录状态');
  NProgress.start()
  // console.log('to: ',to);
  // console.log('from: ',from);
  if (getToken()) {
    const routes = router.getRoutes();
    if(routes.find((it) => it.path === to.path)) {
      next()
    } else {
      next('/buy?machineId=' + getMachineId())
    }
  } else {
    // 未登录
    if (authList.indexOf(to.path) !== -1) {
      // console.log('需要授权的页面');
      if (browser.type == ACCESS_PLATFORM.wechat) {
        // console.log('微信登录');
        wxGetConnectUrl().then(response => {
          window.location.href = response.data
        });
      } else if (browser.type == ACCESS_PLATFORM.alipay) {
        // console.log('支付宝登录');
        aliGetConnectUrl().then(response => {
          window.location.href = response.data;
        });
      } else {
        console.log(getToken());
        // debugger
        // if (process.env.NODE_ENV === 'development') {
        //   NProgress.done()
        //   next()
        // }
      }
      NProgress.done()
      next(false)
    } else {
      try {
        // console.log('尝试登录');
        let href = window.location.href;
        if (process.env.NODE_ENV === 'development') {
          if (href.includes("8091/?code") && href.includes("login/wx")) {  //url包括 login/wx 证明为从微信跳转回来的
            window.location.href = thirdpartyAuth.rearrangeWXurl(href);

            NProgress.done()
            next(false)
          }
        } else {
          if (href.includes("cn/?code") && href.includes("login/wx")) {  //url包括 login/wx 证明为从微信跳转回来的
            window.location.href = thirdpartyAuth.rearrangeWXurl(href);

            NProgress.done()
            next(false)
          }
        }

        // debugger
        thirdpartyAuth.returnFromPlatform(to.fullPath)
        const code = thirdpartyAuth.code
        console.log('code==', code)
        // 通过code换取token
        if (browser.type == ACCESS_PLATFORM.wechat) {
          await store.dispatch('user/loginWechatAuth', code)
        } else if (browser.type == ACCESS_PLATFORM.alipay) {
          await store.dispatch('user/loginAlipayAuth', code)
        }
        NProgress.done()
        next('/buy?machineId=' + getMachineId())
      } catch (err) {
        NProgress.done()
        next('/buy?machineId=' + getMachineId())
      }
    }

  }

  // if (getToken()) {
  //   if (to.path === '/home') {
  //     next({ path: '/' })
  //     NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
  //   } else {
  //     if (store.getters.roles.length === 0) {
  //       store.dispatch('GetInfo').then(res => { // 拉取用户信息
  //         let menus=res.data.menus;
  //         let username=res.data.username;
  //         store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
  //           router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
  //           next({ ...to, replace: true })
  //         })
  //       }).catch((err) => {
  //         store.dispatch('FedLogOut').then(() => {
  //           Message.error(err || 'Verification failed, please login again')
  //           next({ path: '/' })
  //         })
  //       })
  //     } else {
  //       next()
  //     }
  //   }
  // } else {
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     next()
  //   } else {
  //     next('/home')
  //     NProgress.done()
  //   }
  // }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js